import type {
    TableRowActionsConfig,
    TableRowActionsMenuItem,
} from "~/components/table/tableRowActions.types";

/** Kanban: phone + edit upfront; profile, disposition, and the rest in the ⋮ menu. */
export function adaptTableRowActionsConfigForKanban<TRow>(
    config: TableRowActionsConfig<TRow> | undefined,
): TableRowActionsConfig<TRow> | undefined {
    if (config === undefined) {
        return undefined;
    }
    const isViewOnlyToolbar =
        config.toolbar.length === 1 &&
        config.toolbar[0] === "view" &&
        (config.moreMenu ?? []).length === 0;
    if (isViewOnlyToolbar === true) {
        return config;
    }
    const isMoreMenuToolbarOnly =
        config.toolbar.length === 1 &&
        config.toolbar[0] === "more" &&
        (config.moreMenu ?? []).length > 0;
    if (isMoreMenuToolbarOnly === true) {
        return config;
    }
    const isInQueueToolbarOnly =
        config.toolbar.includes("edit") === true &&
        config.toolbar.includes("view") === true &&
        config.toolbar.includes("more") !== true &&
        (config.moreMenu ?? []).length === 0;

    if (isInQueueToolbarOnly === true) {
        return {
            ...config,
            toolbar: ["edit", "view"],
            moreMenu: [],
        };
    }

    const moreMenu: TableRowActionsMenuItem[] = [];

    if (config.toolbar.includes("profile")) {
        moreMenu.push("profile");
    }
    if (config.toolbar.includes("disposition")) {
        moreMenu.push("disposition");
    }
    for (const item of config.moreMenu ?? []) {
        if (!moreMenu.includes(item)) {
            moreMenu.push(item);
        }
    }

    return {
        ...config,
        toolbar: ["edit", "more"],
        moreMenu,
        getActiveState: (row) => {
            const state = config.getActiveState?.(row) ?? {};
            const more =
                state.more === true ||
                state.profile === true ||
                state.disposition === true ||
                state.view === true ||
                state.create === true ||
                state.notes === true ||
                state.scheduleCall === true ||
                state.archive === true;

            return {
                ...state,
                more,
            };
        },
    };
}
